const { AppDispatcher } = require("@cirrus/legacy/app-common/dispatcher")

module.exports = {
  load: function (data) {
    AppDispatcher.dispatch({
      type: "CURRENT_USER_LOADED",
      data: {
        regionalSettings: data.regs,
        features: data.features,
        settings: data.settings,
        defaultAvatar: "../../static/img/default-avatar.png",
      },
    })
  },
}
